import React, {Component} from 'react'
import {Card, Table, message, Spin} from 'antd'
import {decode} from 'utf8'

import {connect} from 'react-redux'
import ModalCoupons from './ModalCoupons';

const columns = [
  {
    title: 'Id',
    dataIndex: 'id',
    key: 'id',
    render: text => <span>{text}</span>,
  },
  
  {
    title: 'Tienda',
    dataIndex: 'store_name',
    key: 'store_name',
  },
  {
    title:'Nombre cupón',
    dataIndex: 'name',
    key: 'name',
  },
  {
    title: 'Inventario inicial',
    dataIndex: 'initialInventory',
    key: 'initialInventory',
  },
  {
    title: 'Comprados',
    dataIndex: 'purchasedCoupons',
    key: 'purchasedCoupons',
  },
  {
    title: 'Canjeados',
    dataIndex: 'redeemedCoupons',
    key: 'redeemedCoupons',
  },
  {
    title: 'Disponibles',
    dataIndex: 'balance',
    key: 'balance',
  },
  {
    title: 'Ver',
    key: 'Ver',


    render: (text,record) => (
      <span>
        <ModalCoupons   recording={record}/>
      </span>
    ),
  }
]

class TableBalance extends Component {
  render() {
    return (
      <Table
        className="gx-table-responsive"
        columns={columns}
        dataSource={this.props.balanceReport}
      />
    )
  }
}

function mapStateToProps({reports}) {
  const {balanceReport} = reports
  return {
    balanceReport,
  }
}
export default connect(mapStateToProps)(TableBalance)



// WEBPACK FOOTER //
// ./src/routes/main/Reports/balance/TableBalance.js